
	export default {
		props: {
			rules: Object,
			value: {
				type: Array,
				default: () => []
			},
			answers: {
				type: Object,
				default: () => ({})
			},
		},
		data() {
			return {
				checkboxes: [
					{
						title: 'DM',
						fullTitle: 'Diabetes'
					},
					{
						title: 'Obesity',
						fullTitle: 'Obesity'
					},
				]
			}
		},
		methods: {
			updateValue(event, option) {
				let answers = this.answers;
				let newValue = [...this.value];

				if (event.target.checked) {
					if (!newValue.includes(option)) {
						newValue.push(option);
					}
					answers.isQuestionThird = true;
				} else {
					newValue = newValue.filter(o => o !== option);
					answers.isQuestionThird = false;
				}

				this.$emit('input', newValue);
			},
			isRuleEnabled(ruleName) {
			 	return this.rules[ruleName] === true;
			}
		}
	}
